import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { templates } from '../../mockData';
import './Templates.css';

function Templates() {
  const { Title } = Typography;

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    { title: 'Variables', dataIndex: 'variables', key: 'variables', render: (vars) => (vars || []).map((v) => <Tag key={v}>{v}</Tag>) },
  ];

  return (
    <div className="agency-creatives-templates">
      <Title level={3}>Templates & Presets</Title>
      <Table rowKey="id" columns={columns} dataSource={templates} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default Templates;
